import React from 'react';
import { PPVFont, textStyles } from '../../theme/fonts-ppv';
import { Colors } from '../../theme';

export const IN_RANGE_BG = '#f4f6f8';
const BORDER_COLOR = '#d9d9d9';
const TEXT_SECONDARY = '#6d6d6d';
export const TEXT_DISABLED = '#bfbfbf';

export default {
  floatingLabel: {
    ...textStyles.h6,
    fontFamily: PPVFont.SemiBold,
    position: 'absolute',
    top: -10,
    left: 10,
    padding: '0 4px',
    background: '#fff',
    fontSize: 12,
    color: Colors.tertiary,
    zIndex: 1,
    pointerEvents: 'none',
    lineHeight: '18px',
    transition: '0.2s ease all',
  } as React.CSSProperties,

  triggerBase: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 8,
    padding: '11px 12px',
    borderRadius: 8,
    background: '#fff',
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: 'nowrap' as const,
    transition: 'border-color 0.2s',
  } as React.CSSProperties,

  triggerIcon: {
    fontSize: 14,
    flexShrink: 0,
  } as React.CSSProperties,

  triggerText: {
    ...textStyles.body2,
    flex: 1,
    textAlign: 'left' as const,
    color: '#1D2055',
  } as React.CSSProperties,

  triggerChevron: {
    fontSize: 11,
    flexShrink: 0,
    transition: 'transform 0.2s',
  } as React.CSSProperties,

  dropdown: {
    position: 'absolute',
    left: 0,
    top: 'calc(100% + 8px)',
    zIndex: 1050,
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
    border: `1px solid ${BORDER_COLOR}`,
    display: 'flex',
    width: 620,
  } as React.CSSProperties,

  sidebar: {
    width: 160,
    borderRight: '1px solid #f0f0f0',
    padding: '12px 0',
    background: '#fafafa',
    borderRadius: '8px 0 0 8px',
    flexShrink: 0,
  } as React.CSSProperties,

  sidebarTitle: {
    ...textStyles.h5,
    fontSize: 14,
    color: Colors.textPrimary,
    padding: '0 12px 8px',
  } as React.CSSProperties,

  sidebarBtn: {
    ...textStyles.body2,
    width: '100%',
    textAlign: 'left' as const,
    padding: '6px 12px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.15s',
    fontFamily: PPVFont.Medium,
    color: Colors.secondary,
  } as React.CSSProperties,

  sidebarBtnInner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 6,
  } as React.CSSProperties,

  sidebarBullet: {
    color: Colors.secondary,
    fontSize: 14,
    lineHeight: '20px',
  } as React.CSSProperties,

  sidebarItemLabel: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: Colors.secondary,
  } as React.CSSProperties,

  sidebarItemSubtitle: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px',
    color: Colors.secondary,
  } as React.CSSProperties,

  calendarSection: {
    flex: 1,
    padding: 16,
    display: 'flex',
    flexDirection: 'column' as const,
  } as React.CSSProperties,

  calendarNav: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 20,
  } as React.CSSProperties,

  navBtn: {
    padding: 6,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    borderRadius: 6,
    color: TEXT_SECONDARY,
    flexShrink: 0,
    marginTop: 4,
  } as React.CSSProperties,

  navIcon: {
    fontSize: 14,
  } as React.CSSProperties,

  calendarsWrapper: {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    gap: 8,
  } as React.CSSProperties,

  calendarWrapper: {
    flex: 1,
    minWidth: 0,
    padding: '0 4px',
  } as React.CSSProperties,

  monthName: {
    ...textStyles.h4,
    fontFamily: PPVFont.SemiBold,
    fontSize: 13,
    fontWeight: 600,
    color: Colors.textPrimary,
    marginBottom: 8,
    textAlign: 'center',
  } as React.CSSProperties,

  dayHeaderGrid: {
    ...textStyles.h6,
    fontSize: PPVFont.Regular,
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 1,
    marginBottom: 2,
    color: Colors.tertiary,
  } as React.CSSProperties,

  dayHeader: {
    height: 26,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 500,
  } as React.CSSProperties,

  cellGrid: {
    ...textStyles.body2,
    color: '#1D2055',
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 1,
  } as React.CSSProperties,

  cellBase: {
    width: '100%',
    height: 26,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    border: 'none',
    padding: 0,
    transition: 'background 0.15s',
    userSelect: 'none' as const,
  } as React.CSSProperties,

  cellEmpty: {
    height: 26,
  } as React.CSSProperties,

  actionsRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    paddingTop: 16,
    borderTop: '1px solid #f0f0f0',
  } as React.CSSProperties,

  cancelBtn: {
    ...textStyles.button1,
    padding: '7px 20px',
    fontSize: 14,
    fontWeight: 500,
    color: TEXT_SECONDARY,
    background: '#fff',
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'background 0.15s',
  } as React.CSSProperties,

  applyBtn: {
    ...textStyles.button1,
    padding: '7px 20px',
    fontSize: 14,
    fontWeight: 500,
    color: '#fff',
    background: Colors.rbhViolet600,
    border: `1px solid ${Colors.rbhViolet600}`,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'background 0.15s',
  } as React.CSSProperties,
};
